import React, { useEffect } from 'react';
import '../assets/css/ThankYouPage.css';

const ThankYouPage = () => {
    useEffect(() => {
        // Simple download on page load
        const link = document.createElement('a');
        link.href = require('../assets/img/If-you-snore.pdf'); // Fixed case - capital I
        link.download = 'If-you-snore.pdf';
        link.click();
    }, []);

    return (
        <React.Fragment>
            <section className="thank-you-wrapper section-padding">
                <div className="container">
                    <div className="thank-you-page text-center">
                        <h2>Thank you for submitting the details!</h2>
                        <h2>We will contact you soon.</h2>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default ThankYouPage;